<template>
    <div>
        <b-card>
            <div slot="header">
                <strong>PDA Management</strong>
                <div class="card-header-actions">
                    <b-button variant="primary" @click="backtopdamanagement()" size="sm">BACK</b-button>
                </div>
            </div>

            <div>
                <b-row>
                    <b-col md="12">
                        <ul class="nav nav-tabs nav-justified">
                            <li class="nav-item">
                                <a class="nav-link" @click="activeTab = 0" :class="{'active': isActiveTab(0)}">ADD PDA</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" @click="activeTab = 1" :class="{'active' : isActiveTab(1)}">Issues PDA</a>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
            </div>

            <div>
                <b-row>
                    <b-col md="12">
                        <div class="tab-panel" v-if="isActiveTab(0)">
                            <PDA_addpda></PDA_addpda>
                        </div>
                        <div class="tab-panel" v-if="isActiveTab(1)">
                            <PDA_Issues></PDA_Issues>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-card> 
    </div>
</template>

<script>
import PDA_addpda from './PDA_addpda.vue'
import PDA_Issues from './PDA_Issues'
export default {
    data() {
        return {
            activeTab:0,
        }
    },

    components:{
        PDA_addpda,
        PDA_Issues
    },

    created() {
        this.isActiveTab(0)
    },

    methods: {
        isActiveTab(id){
            return this.activeTab===id;
        },

        backtopdamanagement(){
            this.$router.push('/PDA_Management')
        }
    },
}
</script>